/**
 * Maps moment.js display formats to PrimeVue DatePicker tokens.
 * PrimeVue: mm = month number, MM = month name, yy = 4-digit year (with lookahead).
 * When showTime is enabled, PrimeVue appends time itself — dateFormat must be date-only.
 */
const MONTH_LONG = '\u0000ML\u0000'
const MONTH_SHORT = '\u0000MS\u0000'

export function momentFormatToPrimeVue (momentFormat, { dateOnly = false } = {}) {
  if (!momentFormat || typeof momentFormat !== 'string') {
    return undefined
  }

  let format = momentFormat.trim()
  if (dateOnly || /\s+HH?:mm\b/i.test(format)) {
    format = format.replace(/\s+HH?:mm\b.*$/i, '').trim()
  }

  if (!format) {
    return undefined
  }

  return format
    .replace(/MMMM/g, MONTH_LONG)
    .replace(/MMM/g, MONTH_SHORT)
    .replace(/YYYY/g, 'yy')
    .replace(/DD/g, 'dd')
    .replace(/MM/g, 'mm')
    .replace(/D(?!D)/g, 'd')
    .replace(new RegExp(MONTH_LONG, 'g'), 'MM')
    .replace(new RegExp(MONTH_SHORT, 'g'), 'M')
}

export function isTimeOnlyFormat (format) {
  if (!format) {
    return false
  }
  const trimmed = format.trim()
  return /^HH?:mm$/i.test(trimmed)
}

export function formatShowsTime (format) {
  if (!format || isTimeOnlyFormat(format)) {
    return false
  }
  return /\s+HH?:mm\b/i.test(format)
}
